// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "styles" + "." + "f367885adc46b66bc718" + ".js";
};